import type { AppData } from "@/application/types";

export default {
  title: "4YourPlan",
  landingPage: { name: "home.show" },
  vuetifyOptions: {},
} satisfies AppData;
